import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import PDFToOCRUploadView from "./PDFToOCRUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFOCRMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF OCR - Make PDF Searchable, Selectable Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_ocr", title: "Make PDF searcheable" },
    data2: { link: "/pdf_ocr", title: "OCR PDF For Free" },
    data3: { link: "/pdf_ocr", title: "PDF OCR Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert scanned PDFs to editable text online. Extract text with high accuracy using our fast, secure, and powerful PDF OCR tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf ocr, ocr pdf, convert scanned pdf to text, pdf text recognition, online pdf ocr, extract text from pdf, pdf ocr online, scanned pdf ocr, pdf to text ocr, optical character recognition pdf, pdf ocr tool, editable pdf ocr, image to text pdf, pdf text extractor, document ocr, pdf to ocr searchable pdf, convert pdf to searchable pdf online, convert to searchable pdf, convert to selectable pdf online, pdf image to text pdf online,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToOCRUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            maxPageCount={15}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF OCR website provides a powerful and secure solution for converting scanned PDFs and images into editable and searchable text without requiring an internet connection. Designed to work fully offline, this advanced PDF OCR tool processes all files directly on your device, ensuring maximum privacy and data protection. Whether you need to extract text from scanned documents, convert image based PDFs into editable files, or make PDFs searchable, this offline PDF OCR solution delivers accurate and reliable results. The platform supports OCR for PDFs created from scanners, cameras, and image files such as JPG and PNG, preserving layout, fonts, and formatting wherever possible. Users can also access online features when needed, making it a flexible PDF OCR online alternative with offline reliability. Ideal for businesses, students, researchers, and professionals, this tool improves productivity by enabling text search, copy, and edit functions in scanned PDFs. Optimized for speed and accuracy, the website serves as a dependable PDF OCR converter, scan PDF to text tool, and OCR PDF free solution for anyone looking to digitize documents securely. If you are searching for a privacy focused PDF OCR website, an efficient offline OCR tool, or a reliable PDF OCR converter, this platform offers a complete solution for modern document processing needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF OCR Tool"
          why_use={[
            {
              title: "Convert Scanned PDFs into Editable Text",
              description:
                "PDF OCR allows you to convert scanned PDFs and image based documents into editable and selectable text. Using an OCR PDF converter helps reuse content without manual retyping.",
            },
            {
              title: "Make PDFs Searchable",
              description:
                "With PDF OCR software, scanned documents become searchable, allowing users to quickly find keywords and text inside large PDF files.",
            },
            {
              title: "Offline OCR for Data Privacy",
              description:
                "An offline PDF OCR tool processes files directly on your device, keeping sensitive information secure without uploading data to a PDF OCR online service.",
            },
            {
              title: "Save Time and Reduce Manual Effort",
              description:
                "Our PDF OCR converter automates text extraction from scanned documents, helping students, professionals, and businesses save time and effort.",
            },
            {
              title: "Supports Multiple File Formats",
              description:
                "Modern OCR PDF tools support scanned PDFs, JPG, PNG, and other image formats, making OCR PDF free solutions versatile and efficient.",
            },
            {
              title: "Improves Document Accessibility",
              description:
                "PDF OCR enhances accessibility by enabling text selection and screen reader support for scanned PDF documents.",
            },
            {
              title: "Preserves Original Layout",
              description:
                "High quality PDF OCR software maintains original formatting, layouts, and fonts to deliver professional and readable output.",
            },
            {
              title: "Useful for Business and Education",
              description:
                "Businesses use PDF OCR tools to digitize contracts and invoices, while students rely on OCR PDF converters for books, notes, and research documents.",
            },
            {
              title: "Reduces Paper and Storage Needs",
              description:
                "By converting scanned files into searchable PDFs, PDF OCR supports digital documentation and reduces paper usage and physical storage.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "What is PDF OCR?",
              description:
                "PDF OCR (Optical Character Recognition) is a technology that recognizes text in scanned PDF documents and images. It can help convert scanned pages into searchable text, making documents easier to find, read, and manage.",
            },
            {
              title: "How do I use an online PDF OCR tool?",
              description:
                "Open the PDF OCR tool on ShivaPDF.com, select your scanned PDF, choose the available OCR options if required, and start text recognition. When processing is complete, download the resulting file if an output download option is provided.",
            },
            {
              title: "How can I make a scanned PDF searchable?",
              description:
                "Use an OCR tool to recognize the text in scanned PDF pages. OCR can add a searchable text layer to a document, allowing you to search for words and phrases instead of relying only on page images.",
            },
            {
              title: "Can I convert a scanned PDF into editable text?",
              description:
                "Yes, OCR can recognize text from scanned PDF pages and images. Whether you can export the recognized text into an editable format depends on the OCR tool's supported output options.",
            },
            {
              title: "Can I use PDF OCR online for free?",
              description:
                "You can use an online PDF OCR tool to recognize text in scanned documents without installing desktop software. Check ShivaPDF's current tool page for available free usage, file-size limits, and processing restrictions.",
            },
            {
              title: "What is the difference between a scanned PDF and a searchable PDF?",
              description:
                "A scanned PDF often contains page images without searchable text. A searchable PDF contains recognized text, usually through an OCR text layer, so you can find words and phrases using a PDF reader's search feature.",
            },
            {
              title: "Can OCR recognize text from image-based PDFs?",
              description:
                "Yes, OCR is designed to recognize text in image-based documents, including scanned pages and photographs embedded in PDFs. Results depend on image quality, text clarity, and the recognition engine.",
            },
            {
              title: "Can PDF OCR recognize handwritten text?",
              description:
                "Handwriting recognition depends on the OCR technology used. Many standard OCR tools work best with printed text, while handwriting can be more difficult to recognize accurately.",
            },
            {
              title: "Which languages can a PDF OCR tool recognize?",
              description:
                "Supported languages vary by OCR engine. Check the available language options in the tool before processing documents containing English or other languages, including non-Latin scripts.",
            },
            {
              title: "How accurate is PDF OCR?",
              description:
                "OCR accuracy depends on scan resolution, contrast, font style, page alignment, language, and document condition. Clear, high-resolution scans generally produce better results than blurry or distorted pages.",
            },
            {
              title: "Can PDF OCR recognize tables and columns?",
              description:
                "OCR may recognize text in tables and multi-column layouts, but preserving the original structure depends on the recognition engine. Review the result carefully if you need accurate table formatting or column order.",
            },
            {
              title: "Can I extract text from a PDF using OCR?",
              description:
                "Yes, OCR can identify text embedded in scanned PDF pages and make it available for searching or extraction, depending on the tool's output features.",
            },
            {
              title: "Can I use OCR on a password-protected PDF?",
              description:
                "A password-protected PDF may need to be unlocked before OCR can process it. Only process documents you are authorized to access, and follow the tool's supported steps for protected files.",
            },
            {
              title: "Can OCR process large PDF files?",
              description:
                "Large PDFs may take longer to process because OCR analyzes text across document pages. Check the tool's file-size and page limits, and consider splitting a very large PDF into smaller files if necessary.",
            },
            {
              title: "Does OCR change the original PDF?",
              description:
                "An OCR workflow commonly generates a processed PDF or extracted text while leaving the original file unchanged. Save a copy of the original document if you need to preserve the unprocessed version.",
            },
            {
              title: "Can I use PDF OCR on Windows and Mac?",
              description:
                "A browser-based PDF OCR tool can be used on Windows and macOS through a supported web browser. Compatibility and performance depend on the website, browser, and document size.",
            },
            {
              title: "Can I use PDF OCR on an iPhone or Android phone?",
              description:
                "You may be able to use an online PDF OCR tool through your mobile browser. Processing speed and usability depend on your device, browser, connection, and the size of the PDF.",
            },
            {
              title: "Is it safe to use an online PDF OCR tool?",
              description:
                "Document privacy depends on how the website processes and stores files. Before processing confidential documents, review the service's privacy policy and verify whether files are uploaded, stored, or processed locally.",
            },
            {
              title: "Can PDF OCR work offline?",
              description:
                "Offline OCR is possible when the required recognition engine and resources are available locally on your device. A typical online OCR service may require an internet connection to send documents for server-side processing.",
            },
            {
              title: "Why is my PDF OCR result inaccurate?",
              description:
                "Incorrect recognition can occur when pages are blurry, tilted, low-resolution, or contain unusual fonts, complex layouts, or handwritten text. Try using a clearer scan with better contrast and check the recognized text for errors.",
            },
            {
              title: "Can OCR make a PDF accessible?",
              description:
                "OCR can make scanned text available to search and select, which is a useful step toward accessibility. However, a fully accessible PDF may also require correct reading order, document structure, tags, and alternative text.",
            },
            {
              title: "Can I search for words after applying OCR to a PDF?",
              description:
                "If OCR creates a searchable text layer, you can use your PDF reader's search function to find recognized words and phrases throughout the document.",
            },
            {
              title: "Do I need to install software to use PDF OCR?",
              description:
                "A web-based PDF OCR tool generally works in a supported browser without requiring separate desktop software. You can access the tool through ShivaPDF.com and follow the options available on the page.",
            },
            {
              title: "Why should I use ShivaPDF for PDF OCR?",
              description:
                "ShivaPDF provides a web-based destination for PDF tools, including OCR if available on the relevant page. Check the tool's supported languages, output options, file limits, and privacy information to determine whether it meets your document needs.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFOCRMain;
